import PptxGenJS from 'pptxgenjs';
import { LAYOUT, COLORS, FONTS } from '../helpers/constants';
import { addConfidentialDisclaimer, addProjectBadge, addSlideTitle, regularSlideGradient } from '../template-parts';
import { BASE_URL } from '@/config';
import { PPTImageManager } from '../helpers/image-manager';

interface AboutSellerData {
    id: string;
    name: string;
    aboutSeller: string;
}

const WIDTH = LAYOUT.width;
const HEIGHT = LAYOUT.height;
const MARGIN = LAYOUT.margin;

export function aboutSellerSlide(pptx: PptxGenJS, data: AboutSellerData, imageManager: PPTImageManager) {

    const slide = pptx.addSlide();
    const opportunityURL = `${BASE_URL}/opportunities/${data?.id}`;
    const logoBlack = imageManager.get('logo-black');

    // Background gradient
    regularSlideGradient(slide);

    // Dark green section
    slide.addShape(pptx.ShapeType.rect, {
        x: 0,
        y: HEIGHT * 0.5,
        w: WIDTH,
        h: HEIGHT * 0.5,
        fill: { color: COLORS.primary },
        line: { type: 'none' },
    });

    if (logoBlack) {
        slide.addImage({
            data: logoBlack,
            x: 5.26,
            y: 0.24,
            w: 1.92,
            h: 0.58,
        });
    }

    // === 3) Badge PROJECT XXX
    addProjectBadge(slide, data.name);

    // === 4) Title About the seller ===
    addSlideTitle(slide, 'About the seller');

    // === 4.1) Content
    slide.addText(data.aboutSeller, {
        x: MARGIN,
        y: 1.4,
        w: 6.29,
        h: 3.34,
        fontFace: FONTS.body,
        fontSize: 12,
        bold: false,
        align: 'left',
        valign: 'top'
    })

    // === 5) Badge "EXPRESS INTEREST HERE" ===
    slide.addText('EXPRESS INTEREST HERE', {
        x: 2.25,
        y: 5.2,
        w: 3,
        h: 0.45,
        shape: pptx.ShapeType.roundRect,
        fontFace: FONTS.title,
        fontSize: 12,
        bold: true,
        color: COLORS.white,
        align: 'center',
        valign: 'middle',
        fill: { color: COLORS.accent },
        rectRadius: 0.1,
        hyperlink: { url: opportunityURL }
    });

    slide.addText('Transaction Process', {
        x: MARGIN,
        y: 5.7,
        w: WIDTH - MARGIN,
        h: 0.7,
        fontFace: FONTS.title,
        fontSize: 28,
        bold: true,
        color: COLORS.white
    });

    // === 6) Steps Transaction process ===
    slide.addText('1', {
        x: MARGIN,
        y: 6.45,
        w: 0.28,
        h: 0.28,
        shape: pptx.ShapeType.roundRect,
        fontFace: FONTS.title,
        fontSize: 14,
        bold: true,
        color: COLORS.white,
        align: 'left',
        valign: 'middle',
        fill: { color: COLORS.accent },
        rectRadius: 0.5,
    });
    slide.addText([
        {
            text: "Submit Your EoI: ",
            options: {
                bold: true
            }
        },
        {
            text: "Show your interest in a project by submitting your Expression of Interest (EoI) directly through ",
        },
        {
            text: 'app.nteaser.com',
            options: {
                hyperlink: { url: "https://app.nteaser.com" }
            }
        }
    ], {
        x: MARGIN + 0.4, y: 6.4, w: 6, h: 0.75,
        fontSize: 14,
        fontFace: FONTS.body,
        color: COLORS.white,
        align: "left",
    });


    slide.addText('2', {
        x: MARGIN,
        y: 7.27,
        w: 0.28,
        h: 0.28,
        shape: pptx.ShapeType.roundRect,
        fontFace: FONTS.title,
        fontSize: 14,
        bold: true,
        color: COLORS.white,
        align: 'left',
        valign: 'middle',
        fill: { color: COLORS.accent },
        rectRadius: 0.5,
    });
    slide.addText([
        {
            text: "Seller Review: ",
            options: {
                bold: true
            }
        },
        {
            text: "The project owner reviews your EoI to ensure alignment with their sales strategy and objectives.",
        }
    ], {
        x: MARGIN + 0.4, y: 7.25, w: 6, h: 0.5,
        fontSize: 14,
        fontFace: FONTS.body,
        color: COLORS.white,
        align: "left",
    });


    slide.addText('3', {
        x: MARGIN,
        y: 7.84,
        w: 0.28,
        h: 0.28,
        shape: pptx.ShapeType.roundRect,
        fontFace: FONTS.title,
        fontSize: 14,
        bold: true,
        color: COLORS.white,
        align: 'left',
        valign: 'middle',
        fill: { color: COLORS.accent },
        rectRadius: 0.5,
    });
    slide.addText([
        {
            text: "Coordination Meeting: ",
            options: {
                bold: true
            }
        },
        {
            text: "If your EoI qualifies, a meeting will be arranged between buyer and seller to clarify next steps and address key questions.",
        }
    ], {
        x: MARGIN + 0.4, y: 7.79, w: 6, h: 0.75,
        fontSize: 14,
        fontFace: FONTS.body,
        color: COLORS.white,
        align: "left",
    });


    slide.addText('4', {
        x: MARGIN,
        y: 8.65,
        w: 0.28,
        h: 0.28,
        shape: pptx.ShapeType.roundRect,
        fontFace: FONTS.title,
        fontSize: 14,
        bold: true,
        color: COLORS.white,
        align: 'left',
        valign: 'middle',
        fill: { color: COLORS.accent },
        rectRadius: 0.5,
    });
    slide.addText([
        {
            text: "Access to Documentation: ",
            options: {
                bold: true
            }
        },
        {
            text: "After the meeting, access will be granted to all relevant project materials required to prepare and submit a formal offer",
        }
    ], {
        x: MARGIN + 0.4, y: 8.59, w: 6, h: 0.75,
        fontSize: 14,
        fontFace: FONTS.body,
        color: COLORS.white,
        align: "left",
    });

    slide.addText([
        { text: "For further " },
        { text: "assistance or any questions during the process, ", options: { bold: true } },
        { text: "please reach out to us at " },
        { text: "projects@nteaser.com. ", options: { bold: true, hyperlink: { url: "mailto:projects@nteaser.com" } } },
        { text: "We're here to support you at every stage." },
    ], {
        x: MARGIN + 0.4, y: 9.45, w: 6, h: 0.75,
        fontSize: 12,
        fontFace: FONTS.body,
        color: COLORS.accent,
        align: "left",
    });


    // Confidential disclaimer
    addConfidentialDisclaimer(slide);
}
